import { render, staticRenderFns } from "./ProductLocalCustomers.vue?vue&type=template&id=346030d9&"
import script from "./ProductLocalCustomers.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ProductLocalCustomers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports